import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import "./ContactVendor.scss";

const ContactVendor = ({ propertyVendor }) => {
  const [validLogos, setValidLogos] = useState({});

  // Only run in browser
  useEffect(() => {
    if (typeof window === "undefined") return;

    if (!propertyVendor || propertyVendor.length === 0) return;

    const vendorContacts = propertyVendor.filter(
      element => element.ContactType === "Vendor"
    );

    vendorContacts.forEach(contact => {
      if (!contact?.LogoUrl) return;

      const img = new window.Image();
      img.onload = () => {
        setValidLogos(prev => ({
          ...prev,
          [contact.LogoUrl]: true,
        }));
      };
      img.onerror = () => {
        setValidLogos(prev => ({
          ...prev,
          [contact.LogoUrl]: false,
        }));
      };
      img.src = contact.LogoUrl;
    });
  }, [propertyVendor]);

  if (!propertyVendor || propertyVendor.length === 0) {
    return null;
  }

  const vendorContacts = propertyVendor.filter(element => element.ContactType === 'Vendor');

  if (vendorContacts.length === 0) {
    return null;
  }

  return (
    <div className="by-order-section">
      <Container>
        {vendorContacts.map((contact, index) => {
          const logoUrl = contact?.LogoUrl || null;
          const displayName = contact?.DisplayName || (contact?.Company ? `By Order Of ${contact.Company}` : null);
          return (
            <div key={index} className="vendor-info">
              {displayName && (
                <div className="display-name">{displayName}</div>)}
              {logoUrl && validLogos[logoUrl] && (
                <div className="vendor-logo"><img src={logoUrl} alt={displayName} /></div>
              )}
            </div>
          );
        })}
      </Container>
    </div>
  );
};

export default ContactVendor;